/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { TrackDetails as TD } from '../Styles/index'

const TrackDetails: React.FC<TrackDetailsProps> = ({
  img,
  alt = 'Track Cover',
  artist,
  name,
  styles,
}) => {
  const withImage = img && img !== ''

  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <div css={getStyles('trackDetails', {})}>
          {withImage ? (
            <img css={getStyles('trackDetailsImg', {})} src={img} alt={alt} />
          ) : null}
          <div
            css={{
              ...getStyles('trackDetailsText', {}),
              width: withImage ? 'calc(75% - .8em)' : '100%',
            }}
          >
            <h3 css={getStyles('trackDetailsTextArtist', {})}>{artist}</h3>
            <p css={getStyles('trackDetailsTextName', {})}>{name}</p>
          </div>
        </div>
      )}
    </StyledComponent>
  )
}

export default TrackDetails

export interface TrackDetailsProps {
  img?: string
  alt?: string
  artist?: string | React.ReactNode
  name?: string | React.ReactNode
  styles?: TD.StylesObj
}
